import { Component, HostListener, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { StripePurchasePopupComponent } from '../../bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { StripeConfirmationPopupComponent } from '../../bulk-purchase/stripe-purchase-popup/stripe-confirmation-popup/stripe-confirmation-popup.component';
import { EventType } from '../../passport/models/passport.models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CinejoyEventService } from 'src/app/core/services/Cinejoy-event/cinejoy-event.service';
import { StripePurchaseService } from '../../bulk-purchase/stripe-purchase.service';
@Component({
  selector: 'app-all-access-pass',
  templateUrl: './all-access-pass.component.html',
  styleUrls: ['./all-access-pass.component.scss']
})
export class AllAccessComponent implements OnInit {
  powerItems: any = [
    { id: 1, image: '../../../../assets/images/all-access-pass/1.png', title: 'PICTURE', description: 'Unlimited access to ALL Showcase films, all Cinejoy festival long.' },
    { id: 2, image: '../../../../assets/images/all-access-pass/2.png', title: 'POSITION', description: 'Access to all Spotlight and Symposium live events, including premieres, red carpet events, artist Q&A’s, and group discussions.' },
    { id: 3, image: '../../../../assets/images/all-access-pass/3.png', title: 'PLAN', description: 'Enjoy a carefully curated selection of top film premieres before they’re available to the general public.' },
    { id: 4, image: '../../../../assets/images/all-access-pass/4.png', title: 'PASSION', description: 'Purchasing a pass directly supports the artists whose work you watch and rate, helping to elevate global storytelling and creative expression.' },
    { id: 5, image: '../../../../assets/images/all-access-pass/5.png', title: 'PARTNERS', description: 'Individual films and events quickly add up to more than $50.' },
    { id: 6, image: '../../../../assets/images/all-access-pass/6.png', title: 'PERSISTENCE', description: 'Acquire Passholder-Only features such as a personalized Watchlist, VIP lounges, and exclusive passholder events.' },
  ];
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: true,
    dots: true,
    navSpeed: 200,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
      },
      400: {
        items: 1,
        slideBy: 1
      },
      740: {
        items: 1,
        slideBy: 1
      },
      940: {
        items: 3,
        slideBy: 3
      }
    },
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    margin: 15,
    autoHeight: false,
    nav: false,
  }
  isSpotlightSubscriptionActive: boolean = environment.subscription.spotlightSubscriptionActive;
  isShowcaseSubscriptionActive: boolean = environment.subscription.showcaseSubscriptionActive;
  isSubscriptionAllActive: boolean = environment.subscription.subscriptionAllActive;
  isSpotlightSubscribed: boolean = false;
  isAllSubscribed: boolean = false;
  isShowcaseSubscribed: boolean = false;
  isButtonClicked: boolean = false;
  pageUrl: string = '';
  allAccessPassDetails: any;
  section1Content: any;
  section1Images: any;
  section2: any;
  section3: any;
  eventList: any;
  allAccessEvent: any;
  reloadCarousel = true;
  hasRefreshed = false
  
  constructor(public dialog: MatDialog,
    private route: ActivatedRoute,
    public adminService: AdminService,
    private authService: AuthenticationService,
    private cinejoyService: CinejoyEventService,
    private modalService: NgbModal,
    private stripeService: StripePurchaseService
  ) { }

  ngOnInit(): void {
    this.getEvents()
    this.getAllAccessPassDetails();
    this.checkForPurchaseCallback();
    this.authService.checkUserAuthenticated().subscribe((res) => {
      if (res.userId > 0) {
        this.getActiveSubscriptions();
      }
    })
  }

  getAllAccessPassDetails() {
    this.adminService.getAllAccessPassDetails().subscribe((res) => {
      this.allAccessPassDetails = res;

      this.section1Content = this.allAccessPassDetails.find((v: any) => (v.section === 'SECTION_1' && v.contentType === 'Header'));
      this.section1Images = this.allAccessPassDetails.filter((v: any) => v.section === 'SECTION_1' && v.contentType === 'Image');
      this.section2 = this.allAccessPassDetails.filter((v: any) => v.section === 'SECTION_2');
      this.section3 = this.allAccessPassDetails.find((v: any) => v.section === 'SECTION_3');
    }, err => {

    })
  }

  getActiveSubscriptions() {
    this.adminService.getActiveSubscription().subscribe(
      {
        next: (data: any[]) => {
          data?.map(
            (item) => {
              if (item.purchaseTransactionType === 'SUBSCRIPTION_ALL') {
                this.isAllSubscribed = true;
              }
              else if (item.purchaseTransactionType === 'SUBSCRIPTION_SPOTLIGHT') {
                this.isSpotlightSubscribed = true;
              }
              else if (item.purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE') {
                this.isShowcaseSubscribed = true;
              }
            }
          )
        },
        error: (error) => {
          this.openInformationPopup('subscriptionError', '');
        }

      })
  }

  openPaymentFlow(premiere: any, purchaseStage: string, purchaseTransactionType: string): void {
    if (!this.isSubscriptionAllActive) {
      const modalRef = this.modalService.open(PurchaseFlowComponent, {
        size: 'lg',
        backdrop: 'static',
      })
      modalRef.componentInstance.premiere = premiere;
      modalRef.componentInstance.purchaseStage = purchaseStage;
      modalRef.result.then(
        (result) => {

        },
        (reason) => {

        },
      );
    }
    else {
      if (this.isButtonClicked) {
        return;
      }
      this.isButtonClicked = true;
      this.populateCallbackUrl();
      this.authService.checkUserAuthenticated().subscribe(
        (res) => {
          if (res.userId === 0) {
            alert("Please login to creatics to purchase tickets.");
            this.isButtonClicked = false;
            location.href = '/login?referer=cinejoy/all-access-pass'
            return;
          }
          else {
            this.openStripPurchasePopup(purchaseTransactionType);
          }
        },
        (err) => {
          location.reload();
          this.isButtonClicked = false;
        }
      );
    }
  }

  openStripPurchasePopup(purchaseTransactionType: string) {
    if ((purchaseTransactionType === 'SUBSCRIPTION_ALL' && (!this.isAllSubscribed && !(this.isShowcaseSubscribed && this.isSpotlightSubscribed))) || (purchaseTransactionType === 'SUBSCRIPTION_SPOTLIGHT' && (!this.isSpotlightSubscribed && !this.isAllSubscribed)) || (purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE' && (!this.isShowcaseSubscribed && !this.isAllSubscribed))) {
      this.dialog.open(StripePurchasePopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '420px',
        height: 'auto',
        data: {
          eventId: "",
          eventType: EventType.SUBSCRIPTION,
          mode: 'purchase',
          url: this.pageUrl,
          puchaseType: 'subscription',
          purchaseTransactionType: purchaseTransactionType,
          availableSubscription: this.isSpotlightSubscribed ? "SPOTLIGHTSUBSCRIBED" : this.isShowcaseSubscribed ? "SHOWCASESUBSCRIBED" : ""
        },
        position: {
          top: '20px'
        }
      }).afterClosed().subscribe((res) => {
        this.isButtonClicked = false;
      })
    }
    else {
      this.openInformationPopup('subscribed', {
        'allAccessPass': (this.isAllSubscribed || (this.isShowcaseSubscribed && this.isSpotlightSubscribed)) && purchaseTransactionType === 'SUBSCRIPTION_ALL',
        'spotlightAccessPass': this.isSpotlightSubscribed && purchaseTransactionType === 'SUBSCRIPTION_SPOTLIGHT',
        'showcaseAccessPass': this.isShowcaseSubscribed && purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE'
      })
    }
  }

  openInformationPopup(purpose: string, subscription: any): void {
    this.dialog.open(StripeConfirmationPopupComponent, {
      // panelClass: 'pre-schedule-modalbox',
      width: '500px',
      minHeight: '15%',
      maxHeight: '50%',
      position: {
        top: '20px'
      },
      data: {
        invalidUsers: [],
        guestUsers: 0,
        emptyTicketCount: 0,
        ticketPrice: 0,
        purchaseTransactionType: purpose,
        subscription: subscription
      }
    }).afterClosed().subscribe((res) => {
      this.isButtonClicked = false;
    })
  }

  private populateCallbackUrl() {
    this.pageUrl = window.location.href;
  }

  getEvents(): void {
    this.stripeService.getSubscriptionDetails('SUBSCRIPTION_ALL').subscribe((res: any) => {
      this.allAccessEvent = res.subscriptionPrices[0];
    }, err => {

    });
  }

  initiatePurchase(purchaseTransactionType: string) {
    if (this.isButtonClicked) {
      return;
    }
    this.isButtonClicked = true;
    this.populateCallbackUrl();
    this.authService.checkUserAuthenticated().subscribe(
      (res) => {
        if (res.userId === 0) {
          alert("Please login to creatics to purchase tickets.");
          this.isButtonClicked = false;
          location.href = '/login?referer=cinejoy/how-to'
          return;
        }
        else {
          // this.openBulkPurchaseDialog(eventId);
          this.openStripPurchasePopup(purchaseTransactionType);
        }
      },
      (err) => {
        location.reload();
        this.isButtonClicked = false;
      }
    );
  }


  checkForPurchaseCallback() {
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.session_id) {

        this.authService.checkUserAuthenticated().subscribe(
          (res) => {
            if (res.userId === 0) {
              alert('Session expired, Please login back to proceed further');
              location.href = '/login?referer=cinejoy/all-access-pass&session_id=' + queryParams.session_id;
              return;
            }
            else {
              this.openStripPaymentConfirmationPopup(queryParams.session_id);
            }
          },
          (err) => {
            location.reload();
          }
        );

      }
    }
    )
  }

  openStripPaymentConfirmationPopup(sessionId) {
    this.dialog.open(StripePurchasePopupComponent, {
      panelClass: 'pre-schedule-modalbox',
      width: '600px',
      minHeight: 'auto',
      maxHeight: '75%',
      data: {
        eventId: '',
        eventType: 'SPOTLIGHT',
        mode: 'callback',
        puchaseType: 'subscription',
        purchaseTransactionType: 'SUBSCRIPTION', // sending this to manage UI changes 
        sessionId: sessionId
      }
    }).afterClosed().subscribe((res) => {
      this.getActiveSubscriptions();
      this.populateCallbackUrl();
    }
    )
  }

  refreshCarousel() {
    this.reloadCarousel = false;
    setTimeout(() => {
      this.reloadCarousel = true;
    },0);
  }
  
    @HostListener('window:resize', ['$event'])
    checkScreenSize(event:any) {
      const screenWidth = event.target.innerWidth;

    if (screenWidth <= 1000) {
      this.refreshCarousel();
    }

    }
}
